'use strict';

/**
 * Since these constants cut across different products some of the enums may
 * be applicable for a specific product and some may not. As consequence
 * it is *not* recommended that Object.values(metricGroupTypes) be used
 * for the purpose of validation with the possible exception being at the
 * PAPI level which also cuts across products.
 */
module.exports = {
  VENDOR: 'vendor',
  DEVICE: 'device',
  SERVICE: 'service',

  /**
   * Superset of vendor, includes ON_PREM and S3C
   */
  STORAGE_TYPE: 'storageType'
};